import { __assign, __read, __rest, __spread } from "tslib";
import React, { useState, createContext, useContext, useMemo, forwardRef, } from "react";
import classNames from "classnames";
import { createRocket } from "../_util/create-rocket";
import { LayoutContent } from "./LayoutContent";
import { isChildOfType } from "../_util/is-child-of-type";
import { useConfig } from "../_util/config-context";
import { uuid } from "../_util/uuid";
import { useIsomorphicLayoutEffect } from "../_util/use-isomorphic-layout-effect";
import { noop } from "../_util/noop";
var LayoutHeader = createRocket("LayoutHeader", "header.@{prefix}-layout__header");
var LayoutFooter = createRocket("LayoutFooter", "footer.@{prefix}-layout__footer");
var LayoutBodyContext = createContext({
    setSider: noop,
});
export var LayoutSider = forwardRef(function LayoutSider(_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var classPrefix = useConfig().classPrefix;
    var setSider = useContext(LayoutBodyContext).setSider;
    useIsomorphicLayoutEffect(function () {
        var id = uuid();
        setSider(id, true);
        return function () { return setSider(id, false); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement("nav", __assign({ ref: ref, className: classNames(classPrefix + "-layout__sidebar", className) }, props)));
});
LayoutSider.displayName = "LayoutSider";
export var LayoutBody = forwardRef(function LayoutBody(_a, ref) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    var classPrefix = useConfig().classPrefix;
    var _b = __read(useState([]), 2), siders = _b[0], setSiders = _b[1];
    var hasSider = useMemo(function () {
        var hasSider = false;
        React.Children.forEach(children, function (child) {
            if (isChildOfType(child, LayoutSider)) {
                hasSider = true;
            }
        });
        return hasSider;
    }, [children]);
    return (React.createElement(LayoutBodyContext.Provider, { value: {
            setSider: function (id, value) {
                if (value) {
                    setSiders(function (siders) { return __spread(siders, [id]); });
                }
                else {
                    setSiders(function (siders) { return siders.filter(function (i) { return i !== id; }); });
                }
            },
        } },
        React.createElement("section", __assign({ ref: ref, className: classNames(classPrefix + "-layout__body", { "has-subsidebar": hasSider || siders.length > 0 }, className) }, props), children)));
});
LayoutBody.displayName = "LayoutBody";
export var Layout = Object.assign(createRocket("Layout", "section.@{prefix}-layout"), {
    Header: LayoutHeader,
    Body: LayoutBody,
    Footer: LayoutFooter,
    Sider: LayoutSider,
    Content: LayoutContent,
});
//# sourceMappingURL=Layout.js.map